import { createAsyncThunk } from '@reduxjs/toolkit';
import BrandsService from './brands_service';
import {
  getBrandsStart,
  getBrandsSuccess,
  getBrandsFailed,
  getSingleBrandStart,
  getSingleBrandSuccess,
  getSingleBrandFailed,
  getBrandProductsStart,
  getBrandProductsSuccess,
  getBrandProductsFailed
} from './brands_slices';
import { toast } from 'react-toastify';

export const getAllBrands = createAsyncThunk(
  'brands/getAllBrands',
  async (payload, { dispatch }) => {
    try {
      dispatch(getBrandsStart());
      const response = await BrandsService.getAllBrands(payload);
      dispatch(getBrandsSuccess(response));
      return response;
    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch brands';
      toast.error(errorMessage);
      dispatch(getBrandsFailed(errorMessage));
      throw error;
    }
  }
);

export const getSingleBrand = createAsyncThunk(
  'brands/getSingleBrand',
  async (payload, { dispatch }) => {
    try {
      if (!payload?.Id) {
        console.log("Invalid brand ID:", payload?.Id);
        return null;
      }
      
      dispatch(getSingleBrandStart());
      const response = await BrandsService.getSingleBrand(payload);
      
      if (response && response.brand) {
        dispatch(getSingleBrandSuccess(response.brand));
        return response.brand;
      } else {
        dispatch(getSingleBrandSuccess(response));
        return response;
      }
    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch brand details';
      console.error(errorMessage);
      dispatch(getSingleBrandFailed(errorMessage));
      return null;
    }
  }
);


export const getProductsByBrand = createAsyncThunk(
  'brands/getProductsByBrand',
  async (payload, { dispatch }) => {
    try {
      if (!payload?.brandName) {
        const errorMessage = 'Brand name is required';
        toast.error(errorMessage);
        dispatch(getBrandProductsFailed(errorMessage));
        throw new Error(errorMessage);
      }
      
      dispatch(getBrandProductsStart());
      const response = await BrandsService.getProductsByBrand(payload);
      dispatch(getBrandProductsSuccess(response));
      return response;
    } catch (error) {
      const errorMessage = error.message || 'Failed to fetch products for this brand';
      toast.error(errorMessage);
      dispatch(getBrandProductsFailed(errorMessage));
      throw error;
    }
  }
);
